import { IN_APP_OPERATORS } from "../constants/payment";

/**
 * Check if operator should handle payment in-app (no redirect)
 */
export function shouldRenderInApp(operatorName) {
  return IN_APP_OPERATORS.includes(operatorName);
}

/**
 * Navigate to payment URL (same origin or external)
 */
export function navigateToPaymentUrl(paymentLink, navigate) {
  try {
    const url = new URL(paymentLink, window.location.origin);
    const sameOrigin = url.origin === window.location.origin;
    
    if (sameOrigin && url.pathname.startsWith("/")) {
      navigate(url.pathname + url.search + url.hash, { replace: true });
    } else {
      window.location.replace(paymentLink);
    }
  } catch {
    window.location.replace(paymentLink);
  }
}

/**
 * Determine if should redirect based on operator and method
 */
export function shouldRedirect(operatorName, method) {
  return !shouldRenderInApp(operatorName) && method !== "PAY_BY_QRCODE";
}